import { render, staticRenderFns } from "./TransferDatas.vue?vue&type=template&id=356f9104&"
import script from "./TransferDatas.vue?vue&type=script&lang=js&"
export * from "./TransferDatas.vue?vue&type=script&lang=js&"
import style0 from "./TransferDatas.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TransferDatas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports